// extracted by mini-css-extract-plugin
module.exports = {"division_line":"ReaderOptionPanel_division_line__16oH0"};